import React from 'react';
interface ButtonProps {
  children: ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
  fullWidth?: boolean;
  trackEvent?: string;
  onBeforeNavigate?: () => boolean;
}
export function Button({
  children,
  onClick,
  href,
  className = '',
  fullWidth = false,
  trackEvent,
  onBeforeNavigate
}: ButtonProps) {
  const sharedClasses = `
    inline-flex items-center justify-center
    bg-accent text-white font-body font-semibold
    px-8 py-4 text-lg rounded-lg transition-colors duration-200
    hover:bg-accent-hover hover:shadow-md
    ${fullWidth ? 'w-full' : ''}
    ${className}
  `;
  const handleClick = (e: React.MouseEvent) => {
    if (onBeforeNavigate) {
      const shouldProceed = onBeforeNavigate();
      if (!shouldProceed) {
        e.preventDefault();
        return;
      }
    }
    if (trackEvent && typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', trackEvent);
    }
    if (onClick) {
      onClick();
    }
  };
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className={sharedClasses} onClick={handleClick} data-id="element-410">
        {children}
      </a>;
  }
  return <button onClick={handleClick} className={sharedClasses} data-id="element-411">
      {children}
    </button>;
}